import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { STORE_KEYS } from '../keys';

const { persistAtom } = recoilPersist();

export const branchIdAtom = atom<number | null>({
  key: STORE_KEYS.BRANCH_ID,
  default: null,
  effects_UNSTABLE: [persistAtom]
});

export const branchNameAtom = atom<string>({
  key: STORE_KEYS.BRANCH_NAME,
  default: '',
  effects_UNSTABLE: [persistAtom]
});

export const hasBranchSelector = selector({
  key: 'hasBranchSelector',
  get: ({ get }) => get(branchIdAtom) !== null && get(branchIdAtom)! > 0
});

export const getBranchIdOrThrow = (branchId: number | null): number => {
  if (!branchId || branchId <= 0) {
    throw new Error('Please select a branch before continuing.');
  }
  return branchId;
};
